import React from 'react';
import styles from './PageLoader.module.css';

interface PageLoaderProps {
    fullScreen?: boolean;
}

export const PageLoader: React.FC<PageLoaderProps> = ({ fullScreen = false }) => {
    return (
        <div className={`${styles.loaderContainer} ${fullScreen ? styles.fullScreen : ''}`}>
            <div className={styles.spinner}></div>
        </div>
    );
};